// extracted by mini-css-extract-plugin
export default {"selectedUser":"AssignStaffUserModal_selectedUser__CxNzf"};